export default __webpack_public_path__ + "static/media/eletric3.5e89b84c.jpeg";